import { createContext, FC, ReactNode, useContext, useState } from "react";

interface ProXtraFlowState {
    phoneNumber: string;
    setPhoneNumber: (phone: string) => void;
}

const ProXtraFlowContext = createContext<ProXtraFlowState | undefined>(
    undefined,
);

export const ProXtraFlowProvider: FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [phoneNumber, setPhoneNumber] = useState("");

    return (
        <ProXtraFlowContext.Provider value={{ phoneNumber, setPhoneNumber }}>
            {children}
        </ProXtraFlowContext.Provider>
    );
};

export function useProXtraFlow(): ProXtraFlowState {
    const context = useContext(ProXtraFlowContext);

    if (!context) {
        throw new Error(
            "useProXtraFlow must be used within a ProXtraFlowProvider",
        );
    }

    return context;
}
